<template>
                <div class="p-50 text-center">
                    <div class="pb-10">
                        <i class="fs-svg ion-ios-list"></i>
                    </div>
                    <div class="mb-10" >
                        <h5> You have not taken your Active Listening Test.</h5>
                        <p class="mb-10">You have to take the Active Listening training and pass the test to become an active listener.</p>
                        <!-- this should link to active listening test  -->
                        <router-link to="/listener/trainings" tag="button" class="btn btn-sm btn-primary text-uppercase">
                            Take Training
                        </router-link>
                    </div>
                </div>
</template>


<script>
export default {
    
}
</script>